enum SlotGameText {
    // Page
    LOADING_PERCENTAGE = 'C1:LoadingPercentage',
    TEXT_COPIED = 'C35',
    COME_JOIN_THE_GAME = 'L7',
    MACHINE_UNDER_MAINTENANCE = 'L8',
    COMING_SOON_STAY_TUNED = 'L9',
    TODAY = 'L13',
    X_DAYS = 'L14',
    CAN_NOT_RETURN_TO_GAME = 'L38',
    RANDOM = 'L40',
    GAME_RULES = 'C16',
    // basic play message
    TARGET_SPINS = 'C14',
    PLACEING_BET = 'G104',
    GOOD_LUCK = 'G17',
    SPINNING = 'G18',
    NEXT_ROUND_START_IN = 'G19',
    PLACE_BET_IN = 'G20',
    BET_PER_SPIN = 'G21',
    JOIN_THIS_ROUND = 'G22',
    LOBBY_JACKPOT_WIN = 'G23',
    // basic multiple play message
    AUTO_PLAY_STOPPED = 'G92',
    PLAYER_BET_IN_ROOM = 'G105',
    JP_CONTRIBUTION_RESET = 'G106',
    FG_WIN = 'G107',
    JACKPOT_WIN = 'G108',
    // chat
    CHAT_PLACEHOLDER = 'G26',
    // slot result type
    JACKPOT = 'C29',
    FEATURE_GAME = 'C31',
    BIGWIN = 'G34',
    // roadmap
    ROADMAP = 'G32',
    LATESET_SPINS = 'G31',
    // play type
    CROWD_PLAY = 'C3',
    MULTIPLE_PLAY = 'C4',
    ROUND_PLAY = 'C5',
    SINGLE_PLAY = 'C2',
    // Game Screen
    GAME_SCREEN_TOUCHABLE = 'G89',
    GAME_SCREEN = 'G90',

    SEC = 'G29',
    SPINS = 'G30',
    NEXT = 'C37',
    DONE = 'C38',

    // Tutorial
    TUTORIAL_OUTER_LOBBY_COMPLETE_TITLE = 'IOL991',
    TUTORIAL_OUTER_LOBBY_COMPLETE_CONTENT = 'IOL992',
    TUTORIAL_LOBBY_COMPLETE_TITLE = 'IML991',
    TUTORIAL_LOBBY_COMPLETE_CONTENT = 'IML992',
    TUTORIAL_SINGLE_PLAY_COMPLETE_TITLE = 'IS991',
    TUTORIAL_SINGLE_PLAY_COMPLETE_CONTENT = 'IS992',
    TUTORIAL_CROWD_PLAY_COMPLETE_TITLE = 'IC991',
    TUTORIAL_CROWD_PLAY_COMPLETE_CONTENT = 'IC992',
    TUTORIAL_MULTIPLE_PLAY_COMPLETE_TITLE = 'IM991',
    TUTORIAL_MULTIPLE_PLAY_COMPLETE_CONTENT = 'IM992',
    TUTORIAL_ROUND_PLAY_COMPLETE_TITLE = 'IR991',
    TUTORIAL_ROUND_PLAY_COMPLETE_CONTENT = 'IR992',

    COMING_SOON = 'L47',
    WELCOME_TO_WINSLOT = 'L48',
    SELECT_YOUR_GAME_ROOM = 'L49',

    SIMPLE_MULTIPLE_PLAY_GOOD_LUCK = 'G93',
    SIMPLE_MULTIPLE_PLAY_SPINING = 'G94',

    EXIT_GAME_HINT = 'G84',
    EXIT_GAME_HINT_LOST_JP_CONTRIBUTION = 'G101',
    EXIT_GAME_HINT_WITH_BET = 'G111',

    IDLE_TOO_LONG = 'L46',
    FREE_BALANCE = 'G110',

    JP_HAS_BEEN_WON = 'G103',
    BEGINNER = 'G39',
    EXPERT = 'G43',

    CREDIT = 'G112',
}

export default SlotGameText;
